<script>
import Swiper from "swiper";
import Event from "@/components/agenda/Event";

export default {
  name: "EventsSlider",
  components: { Event },
  mounted() {
    this.$nextTick(() => {
      const { slider, nextEl, prevEl } = this.$refs;
      new Swiper(slider, {
        slidesPerView: 3,
        spaceBetween: 24,
        breakpoints: {
          800: {
            slidesPerView: 1
          }
        },
        navigation: { nextEl, prevEl }
      });
    });
  }
};
</script>

<style lang="stylus" scoped>
@import "EventsSlider"
</style>
